import React from "react";
import { extractOGTags } from "utils/networkUtils";

const OGTagsPreview = ({ link }: { link: string }) => {
  const [og, setOg] = React.useState<any>(null);
  React.useEffect(() => {
    if (!link) return;
    setOg(null);
    extractOGTags(link)
      .then((data) => setOg(data))
      .catch(() => setOg(null));
  }, [link]);
  if (!og) return <div style={{ marginTop: 8 }}>Loading preview...</div>;
  return (
    <div style={{ border: "1px solid #eee", borderRadius: 8, padding: 12, marginTop: 8, maxWidth: 500 }}>
      {og.image && (
        <img src={og.image} alt={og.title || "Preview"} style={{ width: "100%", maxHeight: 180, objectFit: "cover", borderRadius: 6 }} />
      )}
      <div style={{ fontWeight: 600, marginTop: 8 }}>{og.title || link}</div>
      {og.description && <div style={{ color: "#666", marginTop: 4 }}>{og.description}</div>}
      <div style={{ color: "#888", fontSize: 12, marginTop: 4 }}>{og.site_name || og.url || link}</div>
    </div>
  );
};

export default OGTagsPreview; 